/* one good chew — theme js. no frameworks. everything is progressive enhancement. */
(function () {
  'use strict';

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('ogc-config').textContent); } catch (e) { CFG = {}; }
  var PRICING = {};
  try { PRICING = JSON.parse(document.getElementById('ogc-pricing').textContent); } catch (e) { PRICING = {}; }
  var PAGE = CFG.page || 'other';
  var PHASE = CFG.phase || '1';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- consent (Consent Mode v2, default denied) ---------- */
  var CONSENT_KEY = 'ogc_consent_v1';
  function getConsent() {
    try { return JSON.parse(localStorage.getItem(CONSENT_KEY)); } catch (e) { return null; }
  }
  function analyticsAllowed() { var c = getConsent(); return !!(c && c.analytics); }
  function marketingAllowed() { var c = getConsent(); return !!(c && c.marketing); }

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;
  gtag('consent', 'default', {
    ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied',
    analytics_storage: 'denied', wait_for_update: 500
  });

  var analyticsLoaded = false;
  function loadAnalytics() {
    if (analyticsLoaded) return;
    var c = getConsent();
    if (!c) return;
    analyticsLoaded = true;
    gtag('consent', 'update', {
      analytics_storage: c.analytics ? 'granted' : 'denied',
      ad_storage: c.marketing ? 'granted' : 'denied',
      ad_user_data: c.marketing ? 'granted' : 'denied',
      ad_personalization: c.marketing ? 'granted' : 'denied'
    });
    if (c.analytics && CFG.ga4) {
      var s = document.createElement('script');
      s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(CFG.ga4);
      document.head.appendChild(s);
      gtag('js', new Date());
      gtag('config', CFG.ga4, { anonymize_ip: true });
    }
    if (c.marketing && CFG.metaPixel && !window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        t = b.createElement(e); t.async = true; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', CFG.metaPixel);
      window.fbq('track', 'PageView');
    }
  }

  function setConsent(analytics, marketing) {
    try { localStorage.setItem(CONSENT_KEY, JSON.stringify({ analytics: !!analytics, marketing: !!marketing, ts: Date.now() })); } catch (e) {}
    if (window.Shopify && window.Shopify.customerPrivacy) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { analytics: !!analytics, marketing: !!marketing, preferences: true, sale_of_data: !!marketing }, function () {}
        );
      } catch (e) {}
    }
    loadAnalytics();
  }

  var banner = document.querySelector('[data-consent-banner]');
  function openBanner(expanded) {
    if (!banner) return;
    banner.hidden = false;
    banner.querySelector('[data-consent-choices]').hidden = !expanded;
  }
  if (banner) {
    if (!getConsent()) openBanner(false); else loadAnalytics();
    banner.addEventListener('click', function (e) {
      var t = e.target.closest('button, a'); if (!t) return;
      if (t.hasAttribute('data-consent-accept')) { setConsent(true, true); banner.hidden = true; }
      if (t.hasAttribute('data-consent-manage')) { e.preventDefault(); banner.querySelector('[data-consent-choices]').hidden = false; }
      if (t.hasAttribute('data-consent-save')) {
        setConsent(banner.querySelector('[name="c_analytics"]').checked, banner.querySelector('[name="c_marketing"]').checked);
        banner.hidden = true;
      }
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-consent-open]'); if (!t) return;
    e.preventDefault(); openBanner(true);
  });

  /* ---------- track() wrapper ---------- */
  var META_MAP = { waitlist_submit: 'Lead', waitlist_success: 'CompleteRegistration', add_to_cart: 'AddToCart' };
  var META_STD = { Lead: true, CompleteRegistration: true, AddToCart: true };
  window.ogcTrack = function (name, params) {
    params = params || {};
    params.page = params.page || PAGE;
    if (analyticsAllowed() && typeof window.gtag === 'function') {
      try { window.gtag('event', name, params); } catch (e) {}
    }
    var metaName = META_MAP[name] || (name === 'size_select' ? 'size_select' : null);
    if (metaName && marketingAllowed() && typeof window.fbq === 'function') {
      try { window.fbq(META_STD[metaName] ? 'track' : 'trackCustom', metaName, params); } catch (e) {}
    }
  };

  /* declarative click events */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track-click]');
    if (el) { try { var d = JSON.parse(el.getAttribute('data-track-click')); window.ogcTrack(d.event, d.params || {}); } catch (err) {} }
    var cta = e.target.closest('[data-cta]');
    if (cta) window.ogcTrack('cta_click', { cta_id: cta.getAttribute('data-cta-id') || '', section: cta.getAttribute('data-section') || '' });
    var g = e.target.closest('[data-guarantee-link]');
    if (g) window.ogcTrack('guarantee_open', {});
    var nav = e.target.closest('[data-nav-item]');
    if (nav) window.ogcTrack('nav_click', { item: nav.getAttribute('data-nav-item') });
  });

  /* ---------- promo bar ---------- */
  var promo = document.querySelector('[data-promo-bar]');
  if (promo) {
    var pk = 'ogc_promo_dismissed';
    var until = 0;
    try { until = parseInt(localStorage.getItem(pk) || '0', 10); } catch (e) {}
    if (until > Date.now()) promo.classList.add('is-dismissed');
    promo.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-dismiss]')) {
        promo.classList.add('is-dismissed');
        try { localStorage.setItem(pk, String(Date.now() + 7 * 864e5)); } catch (err) {}
        return;
      }
      if (e.target.closest('a')) window.ogcTrack('promo_bar_click', { phase: PHASE });
    });
  }

  /* ---------- header: sticky on scroll-up only ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 600 && y > lastY) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  }

  /* mobile menu */
  var burger = document.querySelector('[data-nav-open]');
  var overlayClose = document.querySelector('[data-nav-close]');
  if (burger) burger.addEventListener('click', function () { document.body.classList.add('menu-open'); });
  if (overlayClose) overlayClose.addEventListener('click', function () { document.body.classList.remove('menu-open'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.body.classList.remove('menu-open'); });
  document.querySelectorAll('.nav-overlay a').forEach(function (a) {
    a.addEventListener('click', function () { document.body.classList.remove('menu-open'); });
  });

  /* ---------- accordions ---------- */
  document.querySelectorAll('[data-acc-group]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var item = e.target;
      if (!item.open) return;
      group.querySelectorAll('details[open]').forEach(function (d) { if (d !== item) d.open = false; });
      window.ogcTrack('faq_open', { question_id: item.getAttribute('data-question-id') || item.id, page: group.getAttribute('data-page') || PAGE });
    }, true);
  });
  if (location.hash) {
    var target = document.getElementById(location.hash.slice(1));
    if (target && target.matches('details')) { target.open = true; setTimeout(function () { target.scrollIntoView(); }, 60); }
  }

  /* ---------- size selectors ---------- */
  function sizeLabelPrice(size) {
    var p = PRICING[size]; if (!p) return '';
    return PHASE === '2' ? ('from ' + p.day + ' a day') : ('from ' + p.day + ' a day');
  }
  var stickyPrice = document.querySelector('[data-sticky-price]');
  document.querySelectorAll('[data-size-selector]').forEach(function (sel) {
    sel.addEventListener('change', function (e) {
      if (e.target.name !== 'dog_size') return;
      var size = e.target.value;
      sel.querySelectorAll('.sizes__card').forEach(function (c) { c.classList.remove('is-selected'); });
      var card = e.target.closest('.sizes__card'); if (card) card.classList.add('is-selected');
      var pform = sel.closest('form[data-purchase-module]');
      if (pform) {
        var vmap = {}; try { vmap = JSON.parse(pform.getAttribute('data-variant-map') || '{}'); } catch (er) {}
        var idInput = pform.querySelector('[data-variant-id]');
        if (idInput && vmap[size] != null) idInput.value = vmap[size];
        var pmap = {}; try { pmap = JSON.parse(pform.getAttribute('data-plan-map') || '{}'); } catch (er2) {}
        var planInput = pform.querySelector('[data-selling-plan]');
        if (planInput && pmap[size] != null) planInput.value = pmap[size];
      }
      var p = PRICING[size];
      var line = sel.closest('form, section') && sel.closest('form, section').querySelector('[data-price-line]');
      if (line && p) {
        line.textContent = PHASE === '2'
          ? (p.priceStr + " a month · that's " + p.day + ' a day')
          : (p.priceStr + ' a month · ' + p.day + ' a day');
      }
      if (stickyPrice && p) stickyPrice.textContent = 'from ' + p.day + ' a day';
      window.ogcTrack('size_select', { size: size, location: sel.getAttribute('data-location') || '' });
    });
  });

  /* breed guide sheet */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-breed-guide-open]'); if (!t) return;
    e.preventDefault();
    var href = t.getAttribute('href') || '';
    var sheet = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
    if (!sheet) { var sel = t.closest('[data-size-selector]'); sheet = sel && sel.querySelector('[data-breed-guide]'); }
    if (sheet) sheet.hidden = !sheet.hidden;
  });

  /* ---------- observers ---------- */
  function once(fn) { var done = false; return function () { if (!done) { done = true; fn.apply(null, arguments); } }; }
  if ('IntersectionObserver' in window) {
    var wlSeen = once(function (section) { window.ogcTrack('waitlist_view', { section: section }); });
    document.querySelectorAll('[data-waitlist-module]').forEach(function (m) {
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) { if (en.intersectionRatio >= 0.5) { wlSeen(m.getAttribute('data-section') || ''); obs.disconnect(); } });
      }, { threshold: 0.5 }).observe(m);
    });
    document.querySelectorAll('[data-changelog]').forEach(function (m) {
      var fired = false;
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) { if (en.isIntersecting && !fired) { fired = true; window.ogcTrack('changelog_view', {}); obs.disconnect(); } });
      }, { threshold: 0.3 }).observe(m);
    });
  }

  /* scroll reveal */
  if ('IntersectionObserver' in window && !REDUCED) {
    var revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); revObs.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { revObs.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* stat count-up */
  var _statRow = document.querySelector(".statband__row");
  if (_statRow && "IntersectionObserver" in window && !REDUCED) {
    var _nums = _statRow.querySelectorAll(".statx__n");
    _nums.forEach(function (el) {
      var m = el.textContent.trim().match(/^(\D*)(\d+)(\D*)$/);
      if (!m) { el.setAttribute("data-skip", "1"); return; }
      el.setAttribute("data-pre", m[1]); el.setAttribute("data-to", m[2]); el.setAttribute("data-suf", m[3]);
      el.textContent = m[1] + "0" + m[3];
    });
    var _cObs = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; _cObs.unobserve(en.target);
        _nums.forEach(function (el) {
          if (el.getAttribute("data-skip")) return;
          var to = +el.getAttribute("data-to"), pre = el.getAttribute("data-pre"), suf = el.getAttribute("data-suf"), t0 = null, dur = 1100;
          function step(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = pre + Math.round(to * e) + suf; if (p < 1) requestAnimationFrame(step); }
          requestAnimationFrame(step);
        });
      });
    }, { threshold: 0.35 });
    _cObs.observe(_statRow);
  }

  /* science depth (proof page) */
  var sci = document.querySelector('[data-science-depth]');
  if (sci) {
    var marks = [25, 50, 75, 100], fired = {};
    window.addEventListener('scroll', function () {
      var rect = sci.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) return;
      var pct = Math.min(100, Math.max(0, Math.round((-rect.top / total) * 100)));
      marks.forEach(function (m) { if (pct >= m && !fired[m]) { fired[m] = true; window.ogcTrack('science_depth', { pct: m }); } });
    }, { passive: true });
  }

  /* ---------- sticky cta ---------- */
  var sticky = document.querySelector('[data-sticky-cta]');
  if (sticky && 'IntersectionObserver' in window) {
    var heroCtaVisible = false, moduleVisible = false, footerVisible = false, heroExitedAbove = false, viewedOnce = false;
    function refresh() {
      var show = heroExitedAbove && !heroCtaVisible && !moduleVisible && !footerVisible;
      sticky.classList.toggle('is-visible', show);
      if (show && !viewedOnce) { viewedOnce = true; window.ogcTrack('sticky_cta_view', {}); }
    }
    var heroCta = document.querySelector('[data-hero-cta]');
    if (heroCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          heroCtaVisible = en.isIntersecting;
          if (!en.isIntersecting && en.boundingClientRect.bottom < 0) heroExitedAbove = true;
          if (en.isIntersecting) heroExitedAbove = false;
          refresh();
        });
      }, { threshold: 0 }).observe(heroCta);
    } else { heroExitedAbove = true; }
    document.querySelectorAll('[data-waitlist-module], [data-purchase-module]').forEach(function (m) {
      new IntersectionObserver(function (entries) { entries.forEach(function (en) { moduleVisible = en.isIntersecting; refresh(); }); }, { threshold: 0 }).observe(m);
    });
    var foot = document.querySelector('.site-footer');
    if (foot) new IntersectionObserver(function (entries) { entries.forEach(function (en) { footerVisible = en.isIntersecting; refresh(); }); }, { threshold: 0 }).observe(foot);
    sticky.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a) return;
      window.ogcTrack('sticky_cta_click', {});
      var id = (a.getAttribute('href') || '').split('#')[1];
      var el = id && document.getElementById(id);
      if (el) { e.preventDefault(); el.scrollIntoView(REDUCED ? {} : { behavior: 'smooth' }); }
    });
  }

  /* ---------- referral capture on landing ---------- */
  try {
    var refIn = new URLSearchParams(location.search).get('ref');
    if (refIn && /^[a-z0-9]{4,16}$/i.test(refIn)) localStorage.setItem('ogc_referred_by', refIn);
  } catch (e) {}
  function myRefCode() {
    var c = null;
    try { c = localStorage.getItem('ogc_ref_code'); } catch (e) {}
    if (!c) {
      c = Math.random().toString(36).slice(2, 10);
      try { localStorage.setItem('ogc_ref_code', c); } catch (e) {}
    }
    return c;
  }

  /* ---------- forms ---------- */
  var COPY = {
    email: "that email doesn't look quite right.",
    name12: 'tin lids are only so big - 12 letters max.',
    required: 'we need this one.'
  };
  function setErr(field, msg) {
    var wrap = field.closest('.f__field'); if (!wrap) return;
    var err = wrap.querySelector('.f__err');
    if (msg) { wrap.classList.add('has-error'); if (err) { err.textContent = msg; err.hidden = false; field.setAttribute('aria-describedby', err.id || ''); } }
    else { wrap.classList.remove('has-error'); if (err) err.hidden = true; }
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function validateField(f) {
    if (f.name === 'email') {
      if (!f.value.trim()) { setErr(f, COPY.required); return false; }
      if (!validEmail(f.value.trim())) { setErr(f, COPY.email); return false; }
    }
    if (f.name === 'dog_name' && f.value.length > 12) { setErr(f, COPY.name12); return false; }
    if (f.required && !f.value.trim()) { setErr(f, COPY.required); return false; }
    setErr(f, null); return true;
  }
  document.querySelectorAll('[data-ogc-form] .f__input, [data-waitlist-form] .f__input').forEach(function (f) {
    f.addEventListener('blur', function () { validateField(f); });
  });
  document.querySelectorAll('[data-time-trap]').forEach(function (t) { t.value = String(Date.now()); });

  /* live "name on the tin" preview - the name is real (user-typed), so it updates live */
  function padEdition(n) { n = String(n); return 'Nº' + (n.length >= 3 ? n : ('000' + n).slice(-3)); }
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'dog_name') {
      var v = (e.target.value || '').trim().slice(0, 12).toLowerCase() || 'your dog';
      document.querySelectorAll('[data-tin-preview] [data-tin-name]').forEach(function (t) { t.textContent = v; });
    }
  });

  function klaviyoSubscribe(listId, email, properties, source) {
    properties = properties || {};
    /* A/B: stamp the visitor's active experiment variants onto every signup so results
       are measurable in klaviyo (filter/segment by exp_* profile properties). */
    try { var _ab = window.ogcAB || {}; for (var _k in _ab) { if (_ab.hasOwnProperty(_k)) properties['exp_' + _k] = _ab[_k]; } } catch (e) {}
    if (!CFG.klaviyo || !CFG.klaviyo.companyId || !listId) {
      console.warn('TODO: klaviyo public key / list id not set in theme settings - form ran local success-state only.');
      return Promise.resolve({ local: true });
    }
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email: email, properties: properties || {} } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.klaviyo.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status);
      return { local: false };
    });
  }
  function spamCheck(form) {
    var hp = form.querySelector('[name="website"]');
    if (hp && hp.value) return 'bot';
    var tt = form.querySelector('[data-time-trap]');
    if (tt && Date.now() - parseInt(tt.value || '0', 10) < 3000) return 'wait';
    return 'ok';
  }
  function markSubscribed() {
    try { localStorage.setItem('ogc_subscribed', '1'); } catch (e) {}
  }

  /* waitlist form - email-first two-step capture (size is a skippable follow-up) */
  document.querySelectorAll('[data-waitlist-form]').forEach(function (form) {
    var step1 = form.querySelector('[data-wl-step1]');
    var step2 = form.querySelector('[data-wl-step2]');
    var saved = null;

    function finish(size) {
      if (saved && size) {
        saved.size = size;
        klaviyoSubscribe(CFG.klaviyo && CFG.klaviyo.waitlistList, saved.email, { dog_size: size, dog_name: saved.dog_name }, 'waitlist-size');
        window.ogcTrack('size_select', { size: size, location: 'waitlist-step2' });
      }
      try { sessionStorage.setItem('ogc_wl', JSON.stringify(saved)); } catch (err) {}
      window.location.href = '/pages/waitlist-success';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (step2 && !step2.hidden) { // submit while on step 2 = save size
        var sz = form.querySelector('[name="dog_size"]:checked');
        finish(sz ? sz.value : null);
        return;
      }
      var email = form.querySelector('[name="email"]');
      var dogName = form.querySelector('[name="dog_name"]');
      var ok = validateField(email);
      if (dogName && !validateField(dogName)) ok = false;
      if (!ok) return;
      var verdict = spamCheck(form);
      if (verdict === 'bot') return; // silent for bots
      var btn = form.querySelector('[type="submit"]');
      if (verdict === 'wait') { // human who typed fast: defer, never die silently
        if (btn) btn.classList.add('is-loading');
        setTimeout(function () { form.dispatchEvent(new Event('submit', { cancelable: true })); }, 1600);
        return;
      }
      if (btn) btn.classList.add('is-loading');
      var props = {
        dog_size: '',
        dog_name: dogName ? dogName.value.trim().slice(0, 12) : '',
        ref_code: myRefCode(),
        referred_by: (function () { try { return localStorage.getItem('ogc_referred_by') || ''; } catch (err) { return ''; } })()
      };
      window.ogcTrack('waitlist_submit', { size: '', dog_name_provided: !!props.dog_name });
      saved = { dog_name: props.dog_name, size: '', ref: props.ref_code, email: email.value.trim() };
      klaviyoSubscribe(CFG.klaviyo && CFG.klaviyo.waitlistList, saved.email, props, 'waitlist')
        .then(function () {
          markSubscribed();
          if (btn) btn.classList.remove('is-loading');
          if (step1 && step2) { step1.hidden = true; step2.hidden = false; step2.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' }); }
          else { finish(null); }
        })
        .catch(function () {
          if (btn) btn.classList.remove('is-loading');
          setErr(email, "that didn't send. give it another go.");
        });
    });
    var skip = form.querySelector('[data-wl-skip]');
    if (skip) skip.addEventListener('click', function () { finish(null); });
  });

  /* generic inline forms (footer signup) */
  document.querySelectorAll('[data-ogc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('[name="email"]');
      if (!validateField(email)) return;
      if (!spamCheck(form)) return;
      var listKey = form.getAttribute('data-list') === 'footer' ? (CFG.klaviyo && CFG.klaviyo.footerList) : null;
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.classList.add('is-loading');
      klaviyoSubscribe(listKey, email.value.trim(), {}, form.getAttribute('data-list') || 'site')
        .then(function () {
          markSubscribed();
          var s = form.querySelector('[data-form-success]');
          if (s) { s.hidden = false; form.querySelector('[data-form-fields]').hidden = true; }
        })
        .catch(function () { if (btn) btn.classList.remove('is-loading'); setErr(email, "that didn't send. give it another go."); });
    });
  });

  /* ---------- waitlist success page ---------- */
  var successRoot = document.querySelector('[data-waitlist-success]');
  if (successRoot) {
    var wl = {};
    try { wl = JSON.parse(sessionStorage.getItem('ogc_wl')) || {}; } catch (e) {}
    var pos = null;
    try { var p = new URLSearchParams(location.search).get('pos'); if (p && /^\d+$/.test(p)) pos = parseInt(p, 10); } catch (e) {}
    /* h1: dog-name variant */
    var h1name = successRoot.querySelector('[data-success-dogname]');
    if (h1name && wl.dog_name) h1name.textContent = wl.dog_name;
    else if (h1name) {
      var h1 = successRoot.querySelector('[data-success-h1]');
      if (h1) h1.innerHTML = "you're in. tell your dog to act casual<span class=\"dot\" aria-hidden=\"true\">.</span>";
    }
    /* dog-first held line (§7.4) */
    var held = successRoot.querySelector('[data-success-held]');
    if (held && wl.dog_name) { held.textContent = "that's " + wl.dog_name + "'s spot held."; held.hidden = false; }
    /* position card */
    var posWrap = successRoot.querySelector('[data-position-card]');
    if (posWrap) {
      var posNum = posWrap.querySelector('[data-position-number]');
      /* reframe the queue number as a permanent "dog Nº" edition (the panel's one bet).
         ONLY render a real number from the serverless counter - never fabricate one (fake scarcity). */
      if (pos) {
        var edition = padEdition(pos);
        if (posNum) posNum.textContent = edition;
        document.querySelectorAll('[data-tin-number]').forEach(function (t) { t.textContent = edition; });
        var over = posWrap.querySelector('[data-position-over500]');
        var badge = posWrap.querySelector('[data-founder-badge]');
        if (pos <= 500) { if (badge) badge.hidden = false; if (over) over.hidden = true; }
        else { if (badge) badge.hidden = true; if (over) over.hidden = false; }
      } else {
        /* no counter yet: honest holding state, no invented number */
        var numRow = posWrap.querySelector('[data-position-row]');
        if (numRow) numRow.hidden = true;
        var badge2 = posWrap.querySelector('[data-founder-badge]');
        if (badge2) badge2.hidden = false;
      }
    }
    /* engrave the dog's name on the success tin */
    if (wl.dog_name) {
      document.querySelectorAll('[data-waitlist-success] [data-tin-name]').forEach(function (t) { t.textContent = wl.dog_name; });
    }
    window.ogcTrack('waitlist_success', { position: pos || 0 });
    /* referral link + shares */
    var code = wl.ref || myRefCode();
    var link = 'onegoodchew.com/?ref=' + code;
    var linkOut = successRoot.querySelector('[data-ref-link]');
    if (linkOut) linkOut.textContent = link;
    var shareName = wl.dog_name || 'my dog';
    var shareText = 'i just reserved a spot for ' + shareName + ' on the one good chew waitlist - one chew for joints, coat, tummy and immunity: ' + link;
    successRoot.addEventListener('click', function (e) {
      var b = e.target.closest('[data-share]'); if (!b) return;
      var ch = b.getAttribute('data-share');
      if (ch === 'whatsapp') window.open('https://wa.me/?text=' + encodeURIComponent(shareText), '_blank', 'noopener');
      if (ch === 'copy') {
        navigator.clipboard && navigator.clipboard.writeText(shareText).then(function () {
          b.textContent = 'copied.';
          setTimeout(function () { b.textContent = 'copy link'; }, 1600);
        });
      }
      if (ch === 'native' && navigator.share) navigator.share({ text: shareText }).catch(function () {});
      window.ogcTrack('referral_share', { channel: ch });
    });
    if (!navigator.share) { var nb = successRoot.querySelector('[data-share="native"]'); if (nb) nb.hidden = true; }
    /* size confirmation */
    var sizeCard = successRoot.querySelector('[data-success-size]');
    if (sizeCard && wl.size && PRICING[wl.size]) {
      var pr = PRICING[wl.size];
      sizeCard.querySelector('[data-success-size-name]').textContent = wl.size;
      sizeCard.querySelector('[data-success-size-detail]').textContent =
        pr.band + ' · ' + pr.chews + (pr.chews === 1 ? ' chew a day · ' : ' chews a day · ') + pr.priceStr + ' a month at founder price · ' + pr.day + ' a day';
    } else if (sizeCard) { sizeCard.hidden = true; }
    var editToggle = successRoot.querySelector('[data-size-edit-toggle]');
    if (editToggle) editToggle.addEventListener('click', function (e) {
      e.preventDefault();
      var editor = successRoot.querySelector('[data-size-editor]');
      if (editor) editor.hidden = !editor.hidden;
    });
    var editForm = successRoot.querySelector('[data-size-edit-form]');
    if (editForm) editForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = editForm.querySelector('[name="dog_size"]:checked');
      var n = editForm.querySelector('[name="dog_name"]');
      if (n && !validateField(n)) return;
      wl.size = s ? s.value : wl.size;
      if (n && n.value.trim()) wl.dog_name = n.value.trim().slice(0, 12);
      try { sessionStorage.setItem('ogc_wl', JSON.stringify(wl)); } catch (err) {}
      if (wl.email) klaviyoSubscribe(CFG.klaviyo && CFG.klaviyo.waitlistList, wl.email, { dog_size: wl.size, dog_name: wl.dog_name || '' }, 'waitlist-update');
      location.reload();
    });
    /* progressive profiling: birthday + breed (feeds the a2 nudge + the birthday flow) */
    var profileCard = successRoot.querySelector('[data-success-profile]');
    if (profileCard && wl.email) {
      profileCard.hidden = false;
      var pf = profileCard.querySelector('[data-profile-form]');
      if (pf) pf.addEventListener('submit', function (e) {
        e.preventDefault();
        var day = pf.querySelector('[name="bday_day"]').value;
        var month = pf.querySelector('[name="bday_month"]').value;
        var yearIn = (pf.querySelector('[name="bday_year"]').value || '').trim();
        var breed = pf.querySelector('[name="dog_breed"]').value.trim().slice(0, 40).toLowerCase();
        var errOut = pf.querySelector('[data-profile-err]');
        if (errOut) errOut.hidden = true;
        var props = {};
        if (day || month) {
          if (!(day && month)) { if (errOut) { errOut.textContent = 'we need both the day and the month.'; errOut.hidden = false; } return; }
          var y = /^\d{4}$/.test(yearIn) && +yearIn >= 1990 && +yearIn <= new Date().getFullYear() ? yearIn : '1904';
          var dt = new Date(+y, +month - 1, +day);
          if (dt.getMonth() !== +month - 1) { if (errOut) { errOut.textContent = "that date doesn't exist - check the day."; errOut.hidden = false; } return; }
          props.dog_birthday = y + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
          props.dog_birth_year_known = y === '1904' ? 'false' : 'true';
        }
        if (breed) props.dog_breed = breed;
        if (!Object.keys(props).length) { if (errOut) { errOut.textContent = 'nothing to save yet - add a birthday or a breed first.'; errOut.hidden = false; } return; }
        var pbtn = pf.querySelector('[type="submit"]');
        if (pbtn) pbtn.classList.add('is-loading');
        klaviyoSubscribe(CFG.klaviyo && CFG.klaviyo.waitlistList, wl.email, props, 'success-profile')
          .then(function () {
            if (pbtn) pbtn.classList.remove('is-loading');
            var s = profileCard.querySelector('[data-profile-saved]'); if (s) s.hidden = false;
            window.ogcTrack('profile_saved', { birthday: !!props.dog_birthday, breed: !!props.dog_breed });
          })
          .catch(function () {
            if (pbtn) pbtn.classList.remove('is-loading');
            if (errOut) { errOut.textContent = "that didn't save. give it another go."; errOut.hidden = false; }
          });
      });
    }
  }

  /* ---------- refer page ---------- */
  var referRoot = document.querySelector('[data-refer-page]');
  if (referRoot) {
    var rCode = null, rKnown = false, rWl = {};
    try {
      rCode = localStorage.getItem('ogc_ref_code');
      rWl = JSON.parse(sessionStorage.getItem('ogc_wl')) || {};
      rKnown = !!rCode && (!!localStorage.getItem('ogc_subscribed') || !!rWl.email);
    } catch (e) {}
    var knownCard = referRoot.querySelector('[data-refer-known]');
    var unknownCard = referRoot.querySelector('[data-refer-unknown]');
    var joinCard = referRoot.querySelector('[data-refer-join]');
    if (rKnown) {
      if (knownCard) knownCard.hidden = false;
      var rl = referRoot.querySelector('[data-ref-link]');
      var rLink = 'onegoodchew.com/?ref=' + rCode;
      if (rl) rl.textContent = rLink;
      var rName = rWl.dog_name || 'my dog';
      var rText = 'i just reserved a spot for ' + rName + ' on the one good chew waitlist - one chew for joints, coat, tummy and immunity: ' + rLink;
      referRoot.addEventListener('click', function (e) {
        var b = e.target.closest('[data-share]'); if (!b) return;
        var ch = b.getAttribute('data-share');
        if (ch === 'whatsapp') window.open('https://wa.me/?text=' + encodeURIComponent(rText), '_blank', 'noopener');
        if (ch === 'copy') {
          navigator.clipboard && navigator.clipboard.writeText(rText).then(function () {
            b.textContent = 'copied.';
            setTimeout(function () { b.textContent = 'copy link'; }, 1600);
          });
        }
        if (ch === 'native' && navigator.share) navigator.share({ text: rText }).catch(function () {});
        window.ogcTrack('referral_share', { channel: ch, location: 'refer-page' });
      });
      if (!navigator.share) { var rnb = referRoot.querySelector('[data-share="native"]'); if (rnb) rnb.hidden = true; }
    } else {
      if (unknownCard) unknownCard.hidden = false;
      if (joinCard) joinCard.hidden = false;
    }
  }

  /* ---------- signup popup (phase 1, approved mockup: concern -> details -> success page) ---------- */
  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var POP_KEY = 'ogc_popup_until';
    function popupSuppressed() {
      try {
        if (localStorage.getItem('ogc_subscribed')) return true;
        if (sessionStorage.getItem('ogc_wl')) return true;
        if (parseInt(localStorage.getItem(POP_KEY) || '0', 10) > Date.now()) return true;
      } catch (e) {}
      return false;
    }
    var popupShown = false, lastFocus = null, popConcern = '';
    function typingNow() {
      var a = document.activeElement;
      return a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !popup.contains(a);
    }
    function openPopup(reason) {
      if (popupShown || popupSuppressed()) return;
      if (reason !== 'exit' && typingNow()) return; /* never interrupt someone mid-form */
      popupShown = true;
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      var tt = popup.querySelector('[data-time-trap]'); if (tt) tt.value = String(Date.now());
      var first = popup.querySelector('.popup__chip'); if (first) first.focus();
      window.ogcTrack('popup_open', { reason: reason });
    }
    function closePopup(kind) {
      popup.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      if (kind === 'dismiss') { try { localStorage.setItem(POP_KEY, String(Date.now() + 14 * 864e5)); } catch (e) {} }
      window.ogcTrack('popup_close', { kind: kind || 'dismiss' });
    }
    popup.querySelector('[data-popup-close]').addEventListener('click', function () { closePopup('dismiss'); });
    popup.querySelector('[data-popup-overlay]').addEventListener('click', function () { closePopup('dismiss'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) closePopup('dismiss'); });
    popup.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var vis = Array.prototype.filter.call(popup.querySelectorAll('button, input, [href]'), function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    popup.addEventListener('click', function (e) {
      var c = e.target.closest('[data-popup-concern]'); if (!c) return;
      popConcern = c.getAttribute('data-popup-concern') || 'everything';
      popup.querySelector('[data-popup-step="concern"]').hidden = true;
      var d = popup.querySelector('[data-popup-step="details"]'); d.hidden = false;
      var em = d.querySelector('[name="email"]'); if (em) em.focus();
      window.ogcTrack('popup_concern', { concern: popConcern, skipped: c.hasAttribute('data-popup-skip') });
    });
    var popForm = popup.querySelector('[data-popup-form]');
    if (popForm) popForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = popForm.querySelector('[name="email"]');
      var dogName = popForm.querySelector('[name="dog_name"]');
      var ok = validateField(email);
      if (dogName && !validateField(dogName)) ok = false;
      if (!ok) return;
      var verdict = spamCheck(popForm);
      if (verdict === 'bot') return;
      var btn = popForm.querySelector('[type="submit"]');
      if (verdict === 'wait') {
        if (btn) btn.classList.add('is-loading');
        setTimeout(function () { popForm.dispatchEvent(new Event('submit', { cancelable: true })); }, 1600);
        return;
      }
      if (btn) btn.classList.add('is-loading');
      var props = {
        dog_size: '',
        dog_name: dogName ? dogName.value.trim().slice(0, 12) : '',
        primary_concern: popConcern || 'everything',
        ref_code: myRefCode(),
        referred_by: (function () { try { return localStorage.getItem('ogc_referred_by') || ''; } catch (err) { return ''; } })()
      };
      window.ogcTrack('waitlist_submit', { size: '', dog_name_provided: !!props.dog_name, source: 'popup' });
      var saved = { dog_name: props.dog_name, size: '', ref: props.ref_code, email: email.value.trim() };
      klaviyoSubscribe(CFG.klaviyo && CFG.klaviyo.waitlistList, saved.email, props, 'popup')
        .then(function () {
          markSubscribed();
          try { sessionStorage.setItem('ogc_wl', JSON.stringify(saved)); } catch (err) {}
          window.location.href = '/pages/waitlist-success';
        })
        .catch(function () {
          if (btn) btn.classList.remove('is-loading');
          setErr(email, "that didn't send. give it another go.");
        });
    });
    if (!popupSuppressed()) {
      setTimeout(function () { openPopup('timer'); }, 12000);
      var scrollArmed = true;
      window.addEventListener('scroll', function () {
        if (!scrollArmed || popupShown) return;
        var h = document.documentElement;
        if (h.scrollTop > 400 && (h.scrollTop + window.innerHeight) / h.scrollHeight > 0.35) { scrollArmed = false; openPopup('scroll'); }
      }, { passive: true });
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) openPopup('exit');
      });
    }
  }
})();
